const module = { name: 'swig/lib/dateFormatter', exports: {} }; const exports = module.exports;



import { swig_lib_DateZ as DateZ } from '@grins/fd-modules/splits/require-core';



const _months = {
    full: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    abbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
}


const _days = {
    full: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    abbr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    alt: {
        '-1': 'Yesterday',
        0: 'Today',
        1: 'Tomorrow'
    }
}
module.exports = {
    d(input) {
        return (input.getDate() < 10 ? '0' : '') + input.getDate();
    },
    D(input) {
        return _days.abbr[input.getDay()];
    },
    j(input) {
        return input.getDate();
    },
    l(input) {
        return _days.full[input.getDay()];
    },
    N(input) {
        const d = input.getDay();
        return (d >= 1) ? d : 7;
    },
    S(input) {
        const d = input.getDate();
        return (d % 10 === 1 && d !== 11 ? 'st' : (d % 10 === 2 && d !== 12 ? 'nd' : (d % 10 === 3 && d !== 13 ? 'rd' : 'th')));
    },
    w(input) {
        return input.getDay();
    },
    z(input, offset, abbr) {
        const year = input.getFullYear();
        const e = new DateZ.DateZ(year, input.getMonth(), input.getDate(), 12, 0, 0);
        const d = new DateZ.DateZ(year, 0, 1, 12, 0, 0);
        e.setTimezoneOffset(offset, abbr);
        d.setTimezoneOffset(offset, abbr);
        return Math.round((e - d) / 86400000);
    },
    W(input) {
        const target = new Date(input.valueOf());
        const dayNr = (input.getDay() + 6) % 7;
        target.setDate(target.getDate() - dayNr + 3);
        const fThurs = target.valueOf();
        target.setMonth(0, 1);
        if (target.getDay() !== 4) {
            target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
        }
        return 1 + Math.ceil((fThurs - target) / 604800000);
    },
    F(input) {
        return _months.full[input.getMonth()];
    },
    m(input) {
        return (input.getMonth() < 9 ? '0' : '') + (input.getMonth() + 1);
    },
    M(input) {
        return _months.abbr[input.getMonth()];
    },
    n(input) {
        return input.getMonth() + 1;
    },
    t(input) {
        return 32 - (new Date(input.getFullYear(), input.getMonth(), 32).getDate());
    },
    L(input) {
        return new Date(input.getFullYear(), 1, 29).getDate() === 29;
    },
    o(input) {
        const target = new Date(input.valueOf());
        target.setDate(target.getDate() - ((input.getDay() + 6) % 7) + 3);
        return target.getFullYear();
    },
    Y(input) {
        return input.getFullYear();
    },
    y(input) {
        return (input.getFullYear().toString()).substr(2);
    },
    a(input) {
        return input.getHours() < 12 ? 'am' : 'pm';
    },
    A(input) {
        return input.getHours() < 12 ? 'AM' : 'PM';
    },
    B(input) {
        let hours = input.getUTCHours();
        hours = (hours === 23) ? 0 : hours + 1;
        const beats = Math.abs(((((hours * 60) + input.getUTCMinutes()) * 60) + input.getUTCSeconds()) / 86.4).toFixed(0);
        return ('000'.concat(beats).slice(beats.length));
    },
    g(input) {
        const h = input.getHours();
        return h === 0 ? 12 : (h > 12 ? h - 12 : h);
    },
    G(input) {
        return input.getHours();
    },
    h(input) {
        const h = input.getHours();
        return ((h < 10 || (12 < h && 22 > h)) ? '0' : '') + ((h < 12) ? h : h - 12);
    },
    H(input) {
        const h = input.getHours();
        return (h < 10 ? '0' : '') + h;
    },
    i(input) {
        const m = input.getMinutes();
        return (m < 10 ? '0' : '') + m;
    },
    s(input) {
        const s = input.getSeconds();
        return (s < 10 ? '0' : '') + s;
    },
    O(input) {
        const tz = input.getTimezoneOffset();
        return (tz < 0 ? '-' : '+') + (tz / 60 < 10 ? '0' : '') + Math.abs((tz / 60)) + '00';
    },
    Z(input) {
        return input.getTimezoneOffset() * 60;
    },
    c(input) {
        return input.toISOString();
    },
    r(input) {
        return input.toUTCString();
    },
    U(input) {
        return input.getTime() / 1000;
    },
};
export default module.exports;